export default __webpack_public_path__ + "static/media/showroom44.f5f0ba8a.jpg";